import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';
import { ProductOutwardModel } from 'src/app/content/pages/customer/models/product-outward-model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductOutwardService {

  constructor(private http: HttpClient) { }

  public SaveProductOutward(model: ProductOutwardModel) {
    model.idClient = Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID));
    model.createdBy = Number(localStorage.getItem(LocalStorageConstants.ID));

    // Clean up the model before sending - remove selectcustomer object
    const payload = {
      idProductOutward: model.idProductOutward,
      idClient: model.idClient,
      idCustomer: model.idCustomer,
      deposit: model.deposit,
      depositDate: model.depositDate,
      depositReturnDate: model.depositReturnDate,
      remark: model.remark,
      paymentMethod: model.paymentMethod,
      transactionRefNo: model.transactionRefNo,
      useofProduct: model.useofProduct,
      createdBy: model.createdBy,
      modifiedBy: model.modifiedBy,
      productOutwardItems: model.productOutwardItems
    };

    return this.http.post(environment.apiUrl + 'ProductOutward/SaveProductOutward', payload);
  }

  public UpdateProductOutward(model: ProductOutwardModel) {
    model.idClient = Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID));
    model.modifiedBy = Number(localStorage.getItem(LocalStorageConstants.ID));

    return this.http.post(environment.apiUrl + 'ProductOutward/UpdateProductOutward', model);
  }


  GetAllProductOutwards(): Observable<ProductOutwardModel[]> {
      return this.http.get<ProductOutwardModel[]>(environment.apiUrl + 'ProductOutward/GetAllProductOutwards?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));
    }

  GetProductOutwardById(id): Observable<ProductOutwardModel> {
      return this.http.get<ProductOutwardModel>(environment.apiUrl + 'ProductOutward/GetProductOutwardById?idProductOutward=' + id + '&isProductOutwardItemsRequired=' + true);
    }
}
